<template>
  <div>
    <div v-if="translator.approved">
      <b-message type="is-success">
        {{ $t("bdueCheckSucc") }}
      </b-message>
    </div>
    <div v-else-if="applications.length > 0">
      <b-message type="is-primary">
        {{ $t("waitingForTransApproval") }}
      </b-message>
    </div>
    <div v-else>
      <b-field>
        <b-radio-button v-model="method" native-value="auto" type="is-primary">
          <span>{{ $t("bdueCheck") }}</span>
        </b-radio-button>

        <b-radio-button v-model="method" native-value="manual" type="is-primary">
          <span>{{ $t("manualCertification") }}</span>
        </b-radio-button>
      </b-field>
      <div v-if="method == 'auto'">
        <h3 class="subtitle is-6">
          {{ $t("preferedMethod") }}
        </h3>
        <b-message type="is-primary">
          {{ $t("bdueCheckExplained") }}
        </b-message>
        <b-button :loading="loading" :disabled="loading" @click="autoCheck">
          {{ $t("checkNow") }}
        </b-button>
        <b-message v-if="autoFailed" type="is-danger" class="mt-3">
          {{ $t("bdueCheckFail") }}
        </b-message>
      </div>
      <div v-else>
        <b-field :label="$t('manualCertificationExplained')">
          <div>
            <div v-for="(f, i) in applicationFiles" :key="i" class="mb-3">
              <a :href="f.url" target="_blank">
                <b-button type="is-primary is-light">{{ f.name }}</b-button>
              </a>
            </div>
            <UploadFile
              @fileUploaded="
                (f) => {
                  applicationFiles.push(f);
                }
              "
            />
          </div>
        </b-field>
        <b-field :label="$t('applicationText')">
          <b-input v-model="applicationText" maxlength="4000" type="textarea" :loading="loading" :disabled="loading" />
        </b-field>
        <b-button
          class="is-primary mt-1"
          :loading="loading"
          :disabled="loading || (applicationFiles.length == 0 && applicationText == '')"
          @click="sendApplication"
        >
          {{ $t("checkNow") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions } from "@/firebase";
import UploadFile from "./UploadFile";

export default {
  name: "TranslatorCheck",
  components: {
    UploadFile,
  },
  props: {
    translator: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      method: "auto",
      loading: false,
      applicationText: "",
      applicationFiles: [],
      autoFailed: false,
      applications: [],
    };
  },
  watch: {
    translator: {
      immediate: true,
      handler() {
        this.$bind(
          "applications",
          db.collection("member_translators").doc(this.translator.id).collection("applications"),
        );
      },
    },
  },
  methods: {
    async autoCheck() {
      this.loading = true;
      try {
        let approved = await functions.httpsCallable("CheckTranslator")();
        console.log(approved.data);
        if (approved.data.success == false) {
          this.autoFailed = true;
        }
      } catch (error) {
        console.warn(error);
      }
      this.loading = false;
    },
    async sendApplication() {
      this.loading = true;
      try {
        await functions.httpsCallable("ApplyAsTranslator")({
          applicationFiles: this.applicationFiles,
          applicationText: this.applicationText,
        });
        this.$buefy.toast.open({
          message: this.$t("applicationSend"),
          type: "is-success",
        });
        window.location.reload();
      } catch (err) {
        this.$buefy.toast.open({
          message: this.$t("anError"),
          type: "is-danger",
        });
      }
      this.loading = false;
    },
  },
  firestore() {
    return {};
  },
};
</script>

<style></style>
